<nav [attr.aria-label]="'label_breadcrumbs' | translate">
  @if (crumbs.length > 1) {
    <ol class="breadcrumb">
      @for (crumb of crumbs; track crumb; let last = $last) {
        <li [ngClass]="{ active: last }" class="breadcrumb-item">
          @if (!last && crumb.isLinkToPageAvailable) {
            <a [routerLink]="crumb.path" [queryParams]="crumb.queryParams" [queryParamsHandling]="crumb.queryParamsHandling">
              <ng-template
                [ngTemplateOutlet]="crumb.textTranslated ? textTranslated : text"
                [ngTemplateOutletContext]="{ crumb: crumb }"
              >
              </ng-template>
            </a>
          }
          @if (last || !crumb.isLinkToPageAvailable) {
            <span [attr.aria-current]="last ? 'page' : null">
              <ng-template
                [ngTemplateOutlet]="crumb.textTranslated ? textTranslated : text"
                [ngTemplateOutletContext]="{ crumb: crumb }"
              >
              </ng-template>
            </span>
          }
        </li>
      }
    </ol>
  }

  @if (crumbs.length === 1) {
    <div [attr.aria-hidden]="true" class="breadcrumb">
      <div class="breadcrumb-item active">
        <span>
          <ng-template
            [ngTemplateOutlet]="crumbs[0].textTranslated ? textTranslated : text"
            [ngTemplateOutletContext]="{ crumb: crumbs[0] }"
          >
          </ng-template>
        </span>
      </div>
    </div>
  }

  <ng-template #textTranslated let-crumb="crumb">
    @if (crumb.textTranslated) {
      {{ crumb.textTranslated }}
    } @else {
      @if (crumb.text) {
        {{ crumb.text | translate }}
      }
    }
  </ng-template>
  <ng-template #text let-crumb="crumb">
    @if (crumb.text) {
      {{ crumb.text | translate }}
    }
  </ng-template>
</nav>
